import * as Session from '@svb/api-session-component/dist/components/session';

const addToLocalStorage = (val, searchHistory, maxRecentSearchStore = 20) => {
    let rsearchHistory = searchHistory ? searchHistory : [];
    const uniqueKey = parseInt(Date.now() * Math.random());
    const pushRecentval = { key: uniqueKey, value: val };
    rsearchHistory.unshift(pushRecentval);
    rsearchHistory.splice(maxRecentSearchStore); //max recent search keyword history saved in local storage default to 20
    Session.setSessions('local', [
        {
            key: 'recent-searches',
            value: rsearchHistory
        }
    ])
}

export default addToLocalStorage;